module.exports = __webpack_public_path__ + "static/c6ce717f206ebb4df6c99cb9dd2418a0.svg";